export const ABORTED_NETWORK_ERROR = 'ABORTED'
